import { INavLink } from 'shared/SharedModels';

export interface INavSection {
  section: string;
  links: INavLink[];
}

export const CoreSideNavSections: INavSection[] = [
  {
    section: 'Core',
    links: [
      { redirectTo: '/employer/dashboard', label: 'Dashboard', feature: 'Dashboard' },
      { redirectTo: '/employer/jobs', label: 'My Jobs', feature: 'View Jobs' },
      { redirectTo: '/employer/interviews', label: 'My Interviews', feature: 'Interviews' },
      { redirectTo: '/employer/applicants-to-review', label: 'My Applicants', feature: 'View Assigned Applicants' },
      { redirectTo: '/employer/job/new', label: 'Create Job', feature: 'Create Job' },
    ],
  },
  {
    section: 'Productivity',
    links: [
      { redirectTo: '/employer/create-task', label: 'Create Task', feature: 'CreateTask' },
      { redirectTo: '/employer/calendar', label: 'My Calendar', feature: 'Calendar' },
    ],
  },
  {
    section: 'Insights',
    links: [
      { redirectTo: '/employer/analytics', label: 'My Analytics', feature: 'Analytics' },
    ],
  },
  {
    section: 'Account',
    links: [
      { redirectTo: '/employer/settings/tools/templates/rejection-notification', label: 'Tools And Automation', feature: 'Tools And Automation' },
      { redirectTo: '/employer/settings/account/account-information', label: 'Settings', feature: 'Settings' },
    ],
  },
  {
    section: 'Support',
    links: [
      { redirectTo: '/employer/resources', label: 'Resources', feature: 'Resources' },
      { redirectTo: '/employer/help', label: 'Help', feature: 'Help' },
    ],
  },
];
